import { HttpClient } from '@angular/common/http';
import { Base } from '../base';
import { Claims } from './accounts/claims';

export class Accounts extends Base {
  constructor(protected httpClient: HttpClient, private parent: string) {
    super(httpClient, `${parent}/accounts`);
  }

  of(id: string) {
    id = id.toLowerCase();
    return {
      claims: new Claims(this.httpClient, this.pathJoin(id))
    };
  }
}
